
const helpItems = [
  { keywords: ['影印本', '通用', 'OCR', '功能'], question: '影印本通用OCR功能描述', type: 'text', answer: { content: '影印本通用OCR工具是一款企业级的高质量高性能OCR工具。主要针对影印本文件，特别是包括表格的文件能够转换成文字，同时保有符合原文的逻辑格式，为用户进一步转换成其它文件格式比如：MS Word 或 Adobe PDF 等奠定了基础。' } },
  { keywords: ['影印本', '通用', 'OCR', '噪音'], question: '影印本通用OCR噪音处理', type: 'text', answer: { content: '影印本通用OCR工具对原文件带有的背景噪音比如模糊字体、胡椒噪音（很多灰点）、扫描机器留下的竖线、原文含有的水印、有皱纹或放置倾斜的文件，都有很好的容忍度。同时会过滤掉页眉和页脚。' } },
  { keywords: ['影印本', '通用', 'OCR', '特点'], question: '影印本通用OCR特点', type: 'text', answer: { content: '影印本通用OCR工具能做特殊表格处理，比如跨页合并、左右开放表格等。' } },
  { keywords: ['影印本', '通用', 'OCR', '性能'], question: '影印本通用OCR性能', type: 'text', answer: { content: '影印本通用OCR工具速度快，可以接受多达几百页的长文。' } },
  { keywords: ['影印本', '通用', 'OCR', '限制'], question: '影印本通用OCR限制', type: 'text', answer: { content: '影印本通用OCR工具对A4 纸内识别文字对象是2号字到8号字，不识别手写体、不识别图像。' } }
]

const help = {
  state: {
    helpItems
  },
  mutations: {},

  actions: {}
}

export default help
